module.exports = __webpack_public_path__ + "img/food-delivery.9e9dc3e4.svg";